import React from 'react';

import { StyledTextArea } from './InputText.styles';

export const TextArea = props => {
  return <StyledTextArea {...props} />;
};
